<template>
  <div class="content-padding">
    <v-form role="form" v-on:submit.prevent="update" v-model="valid" ref="form" lazy-validation loading>
      <v-card>
        <v-toolbar color="primary" dark class="elevation-0">
          <v-toolbar-title>{{ $t('entity.myData') }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>

        <v-card-text>
          <v-container fluid grid-list-md>
            <div class="headline">{{ person.personFullName }}</div>
            <div class="grey--text subheading">CC. {{ person.personNumberIdentification }}</div>
          </v-container>
          <v-container fluid grid-list-md>
            <v-row row wrap>
              <v-col xs="12" sm="12" md="6">
                <v-row row wrap>
                  <v-col xs="12" sm="12" md="12">
                    <v-select :label="$tc('type', 1)" v-model="person.personKind" :items="personKinds"></v-select>
                  </v-col>
                </v-row>

                <v-row row wrap>
                  <v-col xs="12" sm="12" md="12">
                    <v-text-field :label="$t('email')" v-model="personEmail1" :counter="128"></v-text-field>
                  </v-col>
                </v-row>
                <v-row row wrap>
                  <v-col xs="12" sm="12" md="12">
                    <v-text-field :label="`Segundo ${$t('email')} (Opcional)`" v-model="personEmail2" :counter="128"></v-text-field>
                  </v-col>
                </v-row>
                <!-- <v-row row wrap>
                  <v-col xs="12" sm="12" md="12">
                    <v-text-field
                      :label="$t('phone')"
                      v-model="person.personPhone"
                      :counter="24"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row row wrap>
                  <v-col xs="12" sm="12" md="12">
                    <v-text-field
                      :label="$tc('address', 1)"
                      v-model="person.personAddress"
                      :counter="64"
                    ></v-text-field>
                  </v-col>
                </v-row> -->
                <v-row row wrap>
                  <v-col xs="12" sm="12" md="12">
                    <v-select :label="$t('bloodType')" v-model="person.personBloodType" :items="personBloodTypes" clearable></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <v-col xs="12" sm="12" md="6">
                <!-- <v-row row wrap>
                  <v-col xs="12" sm="12" md="12">
                    <v-autocomplete
                      :label="$tc('country', 1)"
                      v-model="person.countryCode"
                      item-text="name"
                      item-value="code"
                      :items="countries"
                      clearable
                      @change="disableSelect"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row row wrap>
                  <v-col xs="12" sm="12" md="12">
                    <v-autocomplete
                      :label="$tc('region', 1)"
                      v-model="person.regionCode"
                      item-text="regionName"
                      item-value="regionCode"
                      :items="regions"
                      @change="getCity"
                      clearable
                      :disabled="disabled"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row row wrap>
                  <v-col xs="12" sm="12" md="12">
                    <v-autocomplete
                      :label="$tc('city', 1)"
                      v-model="person.cityCode"
                      item-text="cityName"
                      item-value="cityCode"
                      :items="cities"
                      clearable
                      :disabled="disabled"
                    ></v-autocomplete>
                  </v-col>
                </v-row> -->
                <v-row row wrap>
                  <v-col xs="12" sm="12" md="12">
                    <v-menu v-model="dateModal" :close-on-content-click="false" offset-y max-width="290px" min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field :label="$t('date') + ' de nacimiento'" v-model="dateFormatted" append-icon="event" @blur="person.personBirthday = parseDate(dateFormatted)" readonly v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="person.personBirthday" @input="dateFormatted = formatDate($event)" no-title scrollable></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row row wrap>
                  <v-col xs="12" sm="12" md="12">
                    <v-select :label="$t('gender')" v-model="person.personGender" :items="personGenders" clearable></v-select>
                  </v-col>
                </v-row>
                <v-row row wrap>
                  <v-col xs="12" sm="12" md="12">
                    <v-select :label="$t('maritalStatus')" v-model="person.personMaritalStatus" :items="personMaritalStatus" clearable></v-select>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col xs="12" sm="12" md="12">
                <v-textarea :label="$t('note')" v-model="person.personNote" :counter="128" filled></v-textarea>
              </v-col>
            </v-row>
          </v-container>
          <br />
          <v-btn type="submit" :loading="loading" color="accent" style="color: white">
            <v-icon style="margin-right: 5px">save</v-icon>
            {{ $t('save') }}
          </v-btn>
        </v-card-text>
      </v-card>
      <br />
      <br />
      <br />
    </v-form>
  </div>
</template>
<script>
import { i18n } from '@/i18n'
import { responseException } from '@/assets/js/common'
import { countries } from '@/assets/js/data/countries'
import { getToken } from '@/assets/js/shared/utils.js'

export default {
  name: 'person-index',
  data: function () {
    return {
      disabled: false,
      loading: false,
      dateModal: false,
      dateFormatted: null,
      person: {},
      personKinds: [
        {
          text: 'Natural',
          value: 'Person'
        },
        {
          text: 'Juridica',
          value: 'Company'
        }
      ],
      personGenders: [
        {
          text: 'Masculino',
          value: 'M'
        },
        {
          text: 'Femenino',
          value: 'F'
        }
      ],
      personBloodTypes: ['O-', 'O+', 'A-', 'A+', 'B-', 'B+', 'AB+'],
      personMaritalStatus: [
        {
          text: 'Casado(a)',
          value: 'M'
        },
        {
          text: 'Soltero(a)',
          value: 'S'
        },
        {
          text: 'Union Libre',
          value: 'U'
        },
        {
          text: 'Viudo(a)',
          value: 'W'
        },
        {
          text: 'Divorciado(a)',
          value: 'D'
        },
        {
          text: 'Separado(a)',
          value: 'A'
        }
      ],
      identificationTypes: [],
      countries,
      regions: [],
      cities: [],
      personEmail1: '',
      personEmail2: '',
      valid: false,
      requiredRules: [(v) => !!v || i18n.t('valid.required')]
    }
  },
  methods: {
    formatDate(date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate(date) {
      if (!date) {
        return null
      }
      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    formatToDate(date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day.substring(0, 2)}/${month}/${year}`
    },
    get: function () {
      this.loading = true
      this.$http.get(`common/people/${getToken().personId}`).then(
        (response) => {
          this.person = response.body
          this.personEmail1 = response.body.personEmails[0].email
          this.personEmail2 = response.body.personEmails[1] ? response.body.personEmails[1].email : ''
          if (this.person.countryCode) {
            this.getRegion(this.person.countryCode)
          }
          if (this.person.personBirthday) {
            if (this.person.personBirthday.indexOf('0001') >= 0) {
              this.person.personBirthday = null
            }
          }

          this.dateFormatted = this.formatToDate(this.person.personBirthday)
          this.loading = false
        },
        (response) => {
          this.$swal({
            icon: 'error',
            title: this.$t('errorOcurred'),
            text: responseException(response)
          })
          this.loading = false
        }
      )
    },
    getIdentificationType() {
      this.$http.get('common/identificationtypes/').then(
        (response) => {
          this.identificationTypes = response.body
        },
        (response) => {
          this.$swal({
            icon: 'error',
            title: this.$t('errorOcurred'),
            text: responseException(response)
          })
        }
      )
    },
    // getRegion: function(countryCode) {
    //   if (countryCode !== this.person.countryCode) {
    //     this.person.regionCode = "";
    //     this.person.cityIdCode = "";
    //   }
    //   this.$http.get(`common/regions/?countryCode=${countryCode}`).then(
    //     (response) => {
    //       // console.log("regions > ", response.body);
    //       this.regions = response.body;
    //       if (this.person.regionCode) {
    //         this.getCity(this.person.regionCode);
    //       }
    //     },
    //     (response) => {
    //       this.$swal({
    //   icon: 'error',
    //   title: this.$t('errorOcurred'),
    //        text: responseException(response)
    //        });
    //     }
    //   );
    // },
    // getCity: function(regionCode) {
    //   if (regionCode !== this.person.regionCode) {
    //     this.person.regionCode = "";
    //   }
    //   this.$http
    //     .get(
    //       `common/cities/?countryCode=${this.person.countryCode}&regionCode=${regionCode}`
    //     )
    //     .then(
    //       (response) => {
    //         // console.log("cities > ", response.body);
    //         this.cities = response.body;
    //       },
    //       (response) => {
    //         this.$swal({
    //   icon: 'error',
    //   title: this.$t('errorOcurred'),
    //   text: responseException(response)
    // });
    //       }
    //     );
    // },
    update: function () {
      if (this.$refs.form.validate()) {
        this.loading = true
        // console.log("personUp > ", this.person);
        if (this.personEmail1) this.person.personEmails[0].email = this.personEmail1
        if (this.personEmail2) this.person.personEmails[1].email = this.personEmail2
        this.$http
          .put(`common/people/${this.person.personId}/my-data`, this.person, {
            emulateJSON: true
          })
          .then(
            () => {
              this.$swal({
                icon: 'success',
                title: this.$t('processSuccess'),
                confirmButtonColor: '#8bc34a'
              })
              this.loading = false
            },
            (response) => {
              this.$swal({
                icon: 'error',
                title: this.$t('errorOcurred'),
                text: responseException(response)
              })
              this.loading = false
            }
          )
      }
    }
    // disableSelect() {
    //   if (this.person.countryCode !== 'CO') {
    //     this.disabled = true
    //     this.person.cityCode = ''
    //     this.person.regionCode = ''
    //   } else {
    //     this.disabled = false
    //     this.person.countryCode = 'CO'
    //     this.getRegion('CO')
    //   }
    // },
  },
  mounted: function () {
    this.get()
    this.getIdentificationType()
  },
  computed: {}
}
</script>
